import { Grid } from "@mui/material";
import { useDevice } from "components/DeviceContext.js";

function Footer() {
	const { isMobile } = useDevice();
	return (
		<Grid container >
			<footer style={{
				backgroundColor: 'var(--azul)',
				margin: 0,
				padding: 0,
				width: '100%'
			}}>
				<div style={{
					fontSize: isMobile ? '12px' : '15px',
					padding: '1.8em',
					textAlign: 'center',
					color: 'var(--branco)',
					margin: 0,
				}}>
					<p style={{
					}}>
						© OCBPM 2024. Todos os direitos reservados. Todo conteúdo do site produzido pode ser reproduzido, desde que citada a fonte.
					</p>
				</div>
			</footer>
		</Grid>
	);
}

export default Footer;
